import { render } from "./manage-member.vue?vue&type=template&id=ef4861b0&scoped=true&ts=true"
import script from "./manage-member.vue?vue&type=script&lang=ts"
export * from "./manage-member.vue?vue&type=script&lang=ts"

import "./manage-member.vue?vue&type=style&index=0&id=ef4861b0&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4861b0"]])

export default __exports__